import { render, staticRenderFns } from "./AutoAddInventoryDefaultCostsComponent.vue?vue&type=template&id=2cce15dc&scoped=true"
import script from "./AutoAddInventoryDefaultCostsComponent.vue?vue&type=script&lang=js"
export * from "./AutoAddInventoryDefaultCostsComponent.vue?vue&type=script&lang=js"
import "./AutoAddInventoryDefaultCostsComponent.vue?vue&type=style&index=0&id=2cce15dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cce15dc",
  null
  
)

export default component.exports